module.exports = __webpack_public_path__ + "d77a6391548644fc56ac84e296396b9f.jpg";


//////////////////
// WEBPACK FOOTER
// ./apps/www.relic.com/src/img/franchises/coh_image_1.jpg
// module id = 131
// module chunks = 0